/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectQuarterCommand } from '../../models/update-project-quarter-command';
import { UpdateProjectQuarterCommandResult } from '../../models/update-project-quarter-command-result';

export interface ApiProjectUpdateProjectQuarterPatch$Params {
      body?: UpdateProjectQuarterCommand
}

export function apiProjectUpdateProjectQuarterPatch(http: HttpClient, rootUrl: string, params?: ApiProjectUpdateProjectQuarterPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectQuarterCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectUpdateProjectQuarterPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectQuarterCommandResult>;
    })
  );
}

apiProjectUpdateProjectQuarterPatch.PATH = '/api/Project/UpdateProjectQuarter';
